import styles from './index.module.css'

import React, { useCallback, useLayoutEffect, useRef, useState } from 'react'

import Button from 'components/ui/button'

type Props = {
  children: React.ReactNode
}
export default function HorizScroller(props: Props): React.ReactElement<'div'> {
  const { children } = props
  const parentRef = useRef<HTMLDivElement>(null)
  const [outerWidth, setOuterWidth] = useState(0)
  const [innerWidth, setInnerWidth] = useState(0)
  const [hasLeft, setHasLeft] = useState(false)
  const [hasRight, setHasRight] = useState(false)

  const scroll = (dir: -1 | 1) => {
    // without `scrollPadding` it would be always *one* child off
    // alternative: measure width of every child
    const scrollPadding = 50
    const width = outerWidth - scrollPadding

    parentRef.current?.scrollBy({
      left: dir * width,
      top: 0,
      behavior: 'smooth',
    })
  }

  const hasScroll = outerWidth < innerWidth
  const handleScroll = useCallback(() => {
    const nextScrollLeft = parentRef.current?.scrollLeft ?? 0
    // avoid re-renders by storing false/true in hasLeft/hasRight
    setHasLeft(0 < nextScrollLeft)
    setHasRight(nextScrollLeft < innerWidth - outerWidth)
  }, [innerWidth, outerWidth])
  useLayoutEffect(() => {
    if (!parentRef.current) return
    const { clientWidth: outerWidth, scrollWidth: innerWidth } =
      parentRef.current
    setOuterWidth(outerWidth)
    setInnerWidth(innerWidth)
    handleScroll()
  }, [handleScroll, children])
  return (
    <div className="flc">
      {hasScroll && (
        <Button
          appearance="icon"
          disabled={!hasLeft}
          onClick={() => scroll(-1)}
          icon="arrow-left"
        />
      )}
      <div
        className={styles.horizScrollerParent}
        ref={parentRef}
        onScroll={handleScroll}
      >
        {children}
      </div>
      {hasScroll && (
        <Button
          appearance="icon"
          disabled={!hasRight}
          onClick={() => scroll(1)}
          icon="arrow-right"
        />
      )}
    </div>
  )
}
